export default "__VITE_PUBLIC_ASSET__21c8cda3__"